// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a6c3757c","455":"51e7d0a0","977":"12435178"}[chunkId] + ".chunk.js";
};